<div class="text-center mt-5">
  <ng-container *ngIf="(isOnline$ | async) === false">
    <span class="text-muted pb-5 ">
      📶🚫
      <small><b>Offline</b></small>
    </span>
  </ng-container>
  <p class="text-muted">
    <b>{{ message }}</b>
  </p>
  <button (click)="emitTryAgain()" class="btn btn-secondary">
    Retry
  </button>
</div>
